import { isEpoch } from "daedalus-core";

/**
 * The headers a world's document carries when it was read from an open room of the operation stream.
 */
export const LIVE_EPOCH_HEADER = "X-Live-Epoch";
export const LIVE_SEQ_HEADER = "X-Live-Seq";

/**
 * The request header a tab names a sequence in when it reads a room's document again because its checkpoint
 * there found a difference (ADR-086 note 139); the build server logs it and answers as without it.
 */
export const LIVE_DIVERGED_HEADER = "X-Live-Diverged";

/**
 * Where in a room's stream a document was read: the room's epoch and the sequence the document is at.
 */
export interface LivePoint {
  readonly epoch: string;
  readonly seq: number;
}

/**
 * The room a served document was read from, as its `X-Live-Epoch` and `X-Live-Seq` name it (ADR-086 decision
 * 22). Both must be what a room names, since a tab resumes from them: an epoch by the protocol's rule, and a
 * sequence written as a whole number a double holds exactly.
 *
 * @param epoch The epoch header, or null.
 * @param seq The sequence header, or null.
 * @returns The point, or null when the document was the head (no room was open) or a header does not read.
 */
export function livePointOf(epoch: string | null, seq: string | null): LivePoint | null {
  if (epoch === null || seq === null || !isEpoch(epoch) || !/^(0|[1-9][0-9]{0,15})$/.test(seq) || !Number.isSafeInteger(Number(seq))) {
    return null;
  }
  return { epoch, seq: Number(seq) };
}
